// extracted by mini-css-extract-plugin
export default {"header":"TemplateListHeader_header__HQMUy"};